(function ($) {

  /*
   *  render_map
   *
   *  This function will render a Leaflet Map onto the selected jQuery element
   *
   *  @type	function
   *  @date	8/11/2013
   *  @since	4.3.0
   *
   *  @param	$el (jQuery element)
   *  @return	n/a
   */

  function render_map($el) {

    var $markers = $el.find('.marker');

    var self = this;
    self.map = {};

    function initMap() {

      var proj = d3.geo.albersUsa()
        .scale(0.5);

      var AlbersProjection = {
        project: function (latLng) {
          var point = proj([latLng.lng, latLng.lat]);
          return point ?
            new L.Point(point[0], point[1]) :
            new L.Point(0, 0);
        },
        unproject: function (point) {
          var latLng = proj.invert([point.x, point.y]);
          return new L.LatLng(latLng[1], latLng[0]);
        }
      };

      var AlbersCRS = L.extend({}, L.CRS, {
        projection: AlbersProjection,
        transformation: new L.Transformation(1, 0, 1, 0),
        infinite: true
      });

      // attribution removed, sorry Vladimir! https://groups.google.com/g/leaflet-js/c/fA6M7fbchOs/m/JTNVhqdc7JcJ
      var center = [37.8, -96];
      self.map = new L.map($el[0], {
          zoomSnap: 0.25,
          crs: AlbersCRS,
          scrollWheelZoom: false,
          tap: false,
          zoomControl: false,
          dragging: false,
          doubleClickZoom: false,
          attributionControl: false,
        })
        .setView(center, 3);

      var layer;
      d3.json("/wp-content/themes/wsb/assets/dist/json/us-states-albers.json", function (error, data) {
        if (error) return console.error(error);
        layer = L.geoJson(data, {
            style: {

            }
          })
          .addTo(self.map);
      });

      // Create an OverlappingMarkerSpiderfier instance:
      var oms = new OverlappingMarkerSpiderfier(self.map);


      // -------------------------------------------
      // CUSTOMIZE MARKERS 
      // -------------------------------------------
      var defaultMarkerIcon = L.icon({
        iconUrl: '/wp-content/themes/wsb/assets/dist/img/map-alumni/marker-icon.png',
        iconRetinaUrl: "/wp-content/themes/wsb/assets/dist/img/map-alumni/marker-icon@2x.png",
        shadowUrl: '/wp-content/themes/wsb/assets/dist/img/map-alumni/marker-shadow.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        tooltipAnchor: [16, -28],
        shadowSize: [41, 41]
      });

      var highlightMarkerIcon = L.icon({
        iconUrl: '/wp-content/themes/wsb/assets/dist/img/map-alumni/marker-icon-highlight.png',
        iconRetinaUrl: "/wp-content/themes/wsb/assets/dist/img/map-alumni/marker-icon-highlight@2x.png",
        shadowUrl: '/wp-content/themes/wsb/assets/dist/img/map-alumni/marker-shadow.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        tooltipAnchor: [16, -28],
        shadowSize: [41, 41]
      });
      var hiddenMarkerIcon = L.icon({
        iconUrl: '/wp-content/themes/wsb/assets/dist/img/map-alumni/marker-icon.png',
        iconRetinaUrl: "/wp-content/themes/wsb/assets/dist/img/map-alumni/marker-icon@2x.png",
        shadowUrl: '/wp-content/themes/wsb/assets/dist/img/map-alumni/marker-shadow.png',
        iconSize: [1, 1],
        iconAnchor: [1, 1],
        popupAnchor: [1, 1],
        tooltipAnchor: [1, 1],
        shadowSize: [1, 1]
      });

      // -------------------------------------------
      // ADD INTL 
      // -------------------------------------------

      self.map.markers_intl = [];

      var $markers_intl = $el.find('.marker_intl');

      $markers_intl.each(function (i) {
        add_marker_intl($(this), self.map, i);
      });

      function marker_click(index) {
        self.map.markers_intl[index].openPopup();

      }

      function add_marker_intl($marker_intl, map, num) {
        var latlng = L.latLng($marker_intl.attr('data-lat'), $marker_intl.attr('data-lng'));
        var marker_intl_country = $marker_intl.find('.country').html();
        let markup = '';

        // create marker
        var marker_intl = L.marker([32.2299, -126.4909], {
          title: marker_intl_country,
          icon: hiddenMarkerIcon,
          opacity: 1,
          alt: marker_intl_country,
        }).addTo(map);

        var popup = L.responsivePopup({
          autoPanPadding: [40, 40],
          hasTip: false
        }).setContent($marker_intl.html());
        marker_intl.bindPopup(popup);
        self.map.markers_intl.push(marker_intl);

        markup = '<a class="mx-2 text-dark" href="javascript:void(0);" onclick="javascript:map.markers_intl[' + num + '].openPopup();"><span class="marker"></span> <strong>' + marker_intl_country + '</strong> </a>';
        //document.getElementById('map-international-locations').innerHTML = markup;
        $("#map-international-locations").append(markup);
      }

      // -------------------------------------------
      // ADD MARKERS 
      // -------------------------------------------
      // add a markers reference
      self.map.markers = [];
      // add markers
      $markers.each(function (i) {
        add_marker($(this), self.map, i);
      });

      function add_marker($marker, map, num) {
        var latlng = L.latLng($marker.attr('data-lat'), $marker.attr('data-lng'));

        // create marker
        var marker = L.marker(latlng, {
          title: "",
          icon: defaultMarkerIcon,
        }).addTo(map);

        var popup = L.responsivePopup({
          autoPanPadding: [40, 40],
          hasTip: false
        }).setContent($marker.html());

        marker.bindPopup(popup);
        marker.on('mouseover', function (e) {
          //leaflet-marker-icon
          e.target.setIcon(highlightMarkerIcon);
        });
        marker.on('mouseout', function (e) {
          e.target.setIcon(defaultMarkerIcon);
        });



        // Notify OverlappingMarkerSpiderfier of the marker
        oms.addMarker(marker);

      }
    }

    function initEvents() {

      /* -------------------------------------------
      // RECENTER WHEN POPUP CLOSED
      // -------------------------------------------
      self.map.on('popupclose', function (e) {
        self.map.panTo(new L.LatLng(37.8, -96));
      });
*/

      // -------------------------------------------
      // RESIZE MAP
      // -------------------------------------------
      $(window).on("resize", function () {
        var width = document.documentElement.clientWidth;
        // tablets are between 768 and 922 pixels wide
        // phones are less than 768 pixels wide
        if ((width <= 280)) {
          self.map.setZoom(1.25);
        } else if ((width <= 375) && (width > 280)) {
          self.map.setZoom(1.5);
        } else if ((width <= 420) && (width > 375)) {
          self.map.setZoom(1.25);
        } else if ((width <= 992) && (width > 420)) {
          self.map.setZoom(2);
        } else if (width > 992) {
          self.map.setZoom(3);
        }

        self.map.invalidateSize();
      }).trigger("resize");

    }

    self.init = function () {
      initMap();
      initEvents();

    };
    self.init();
  }

  /*
   *  document ready
   *
   *  This function will render each map when the document is ready (page has loaded)
   *
   */

  //$(document).ready(function () {
  $('.map').each(function () {
    render_map($(this));
  });
  //});

})(jQuery);